import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faClock,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faExternalLinkAlt,
    faPlus,
    faSave,
    faSearch,
    faSignOutAlt,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import context from './context';
import './index.css';
import {stores} from './Redux/stores';
import {init} from './Redux/init';
import configureServices from './Services';
import AppAuth from './Components/AppAuth';
import { Store } from 'redux';
import { IAuthService } from 'types/auth';

library.add(
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faPlus,
    faSave,
    faTimes,
    faTrash,
    faExternalLinkAlt,
    faSignOutAlt,
    faClock,
    faSearch
);

const render = async (store: Store, authService: IAuthService, appSettingsService: any) => {
    const target = document.getElementById('root');
    const msalClientScopeURL = appSettingsService.GetMsalClientScope();
    const msalApplication = authService.msalApplication;
    
    ReactDOM.render(
        <MsalProvider instance={msalApplication}>
            <Provider store={store}>
                <Router>
                    <AppAuth msalClientScope={msalClientScopeURL} />
                </Router>
            </Provider>
        </MsalProvider>,
        target
    );
};

(async function bootstrap() {
    const services = await configureServices();
    const { actions, reducers } = await stores(services);

    context.registerServices(services);
    context.registerActions(actions);

    render(init(reducers), services.auth, services.appSettings);
})();
